import CancelIcon from '@mui/icons-material/Cancel'
import GridViewIcon from '@mui/icons-material/GridView'
import { Box, Grid, IconButton, Modal, Switch, TextField } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { selectFursuit } from '../../../state/voting/fursuit'
import { Button, TranslatableTypography } from '../widgets'
import { VotingCard } from './Card'

const { pallete } = require('../../../theme')

const votingProfilesStyle = {
  '&': {
    width: '100%',
    height: '100%'
  },
  '& .voting-profiles-filter-input': {
    width: '100%',
    height: '100%',
    padding: '5px',
    '& .Mui-focused': {
      color: pallete.paperColor
    }
  },
  '& .voting-profiles-modal-control': {
    background: pallete.headerColor,
    '& .MuiGrid-item': {
      padding: '5px'
    },
    '& .voting-profiles-switch-hidden': {
      visibility: 'hidden'
    }
  },
  openHeader: {
    wrapper: {
      display: 'inline',
      '& button:hover': { backgroundColor: pallete.headerColor }
    },
    button: { background: pallete.headerColor, padding: '4px' },
    icon: { color: pallete.paperColor, width: '20px', height: '20px', marginRight: '5px' },
    label: {
      fontWeight: '600',
      verticalAlign: 'middle',
      display: 'inline',
      marginLeft: '5px'
    },
    switchLabel: {
      display: 'inline-block',
      color: pallete.paperColor
    },
    switch: {
      '& .MuiSwitch-switchBase': {
        '&.Mui-checked +.MuiSwitch-track': {
          background: pallete.headerBrightColor
        },
        '&.Mui-checked .MuiSwitch-thumb': {
          background: pallete.headerBrightColor
        }
      }
    }
  },
  closeHeader: {
    button: {
      display: 'block',
      width: '100%',
      borderRadius: '0px',
      textAlign: 'right',
      padding: '5px',
      height: '35px',
      lineHeight: '25px',
      marginTop: '5px',
      background: pallete.headerColor
    },
    icon: { color: pallete.paperColor, width: '25px', height: '25px' }
  },
  container: {
    width: '100%',
    height: 'calc(100% - 35px)',
    overflowY: 'scroll',
    padding: '10px',
    textAlign: 'center',
    '& .CompanionVotingCard-wrapper': {
      position: 'absolute',
      right: '5px',
      top: '5px'
    }
  },
  profile: {
    card: {
      '@media (max-width: 539px)': {
        width: '30%',
        margin: '5px'
      },
      '@media (min-width: 540px)': {
        width: '160px',
        margin: '5px'
      },
      cursor: 'pointer',
      position: 'relative',
      height: '160px',
      display: 'inline-block',
      '& .MuiCardMedia-img': { height: '160px' },
      '& .voting-avatar': {
        visibility: 'hidden',
        position: 'absolute',
        top: '0px',
        left: '0px'
      },
      '&.loaded .voting-avatar': {
        visibility: 'visible'
      },
      '& .voting-avatar-loader': {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '100%'
      }
    }
  }
}

export const FursuitProfiles = (props) => {
  const { fursuits, votedUsers, votes } = props
  const [open, setOpen] = useState(false)
  const [filter, setFilter] = useState('')
  const [votedOnly, setVotedOnly] = useState(false)
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }
  const handleVoteOnlySwitch = (e, value) => {
    setVotedOnly(value)
  }

  const votedFilterVisibility = votedUsers.length > 0 ? 'voting-profiles-switch-visible' : 'voting-profiles-switch-hidden'
  const items = fursuits.reduce(function (filtered, fursuit, i) {
    const nameMatchesFilter = filter.trim() === '' || (fursuit.name && fursuit.name.toLowerCase().includes(filter.trim().toLowerCase()))
    const selectedCondition = nameMatchesFilter && (votedUsers.length === 0 || !votedOnly || (votedUsers.includes(fursuit.number) && votedOnly))
    if (selectedCondition) {
      filtered.push(
          <VotingCard
            key={i}
            votes={votes}
            data={fursuit}
            sx={votingProfilesStyle.profile.card}
            onClick={() => {
              dispatch(selectFursuit(fursuit))
              handleClose()
            }}
          />
      )
    }
    return filtered
  }, [])

  const changeFilterHandler = (e) => {
    setFilter(e.target.value)
    if (e.target.value.trim() !== '') {
      setVotedOnly(false)
    }
  }

  const filterFieldProps = {
    onChange: changeFilterHandler,
    label: t('Filter fursuits'),
    variant: 'standard',
    value: filter,
    size: 'small'
  }

  return (
    <Box sx={{
      display: 'inline-block',
      width: '100%',
      textAlign: 'right'
    }}>
      <Box sx={votingProfilesStyle.openHeader.wrapper}>
        <Button
          variant="contained"
          onClick={handleOpen}
          label="All fursuits"
          icon={
            <GridViewIcon
              sx={votingProfilesStyle.openHeader.icon}
            />
          }
        />
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
      >
        <Box sx={votingProfilesStyle}>
          <Grid container className="voting-profiles-modal-control">
            <Grid xs={9} item className={votedFilterVisibility}>
              <TranslatableTypography
                sx={votingProfilesStyle.openHeader.switchLabel}
              >
                Show votes only:
              </TranslatableTypography>
              <Switch
                checked={votedOnly}
                onChange={handleVoteOnlySwitch}
                sx={votingProfilesStyle.openHeader.switch}
              />
            </Grid>
            <Grid xs={3} item>
              <IconButton
                sx={votingProfilesStyle.closeHeader.button}
                onClick={handleClose}
              >
                <CancelIcon sx={votingProfilesStyle.closeHeader.icon} />
              </IconButton>
            </Grid>
            <Grid xs={12} item>
              <TextField className="voting-profiles-filter-input" {...filterFieldProps} />
            </Grid>
          </Grid>
          <Box
            sx={votingProfilesStyle.container}
            className="voting-profiles-modal-scroll"
          >
            {items}
          </Box>
        </Box>
      </Modal>
    </Box>
  )
}
